// extracted by mini-css-extract-plugin
export default {"container":"w29co","divider":"xqP0a"};